export const DecisionLabelColor = {
  gray: "gray",
  red: "red",
  orange: "orange",
  yellow: "yellow",
  green: "green",
  blue: "blue",
  purple: "purple",
  pink: "pink",
} as const;
export type DecisionLabelColor =
  (typeof DecisionLabelColor)[keyof typeof DecisionLabelColor];

export const DECISION_LABEL_COLORS = [
  DecisionLabelColor.gray,
  DecisionLabelColor.red,
  DecisionLabelColor.orange,
  DecisionLabelColor.yellow,
  DecisionLabelColor.green,
  DecisionLabelColor.blue,
  DecisionLabelColor.purple,
  DecisionLabelColor.pink,
] as const;

export const DEFAULT_TRUE_LABEL_COLOR = DecisionLabelColor.green;
export const DEFAULT_FALSE_LABEL_COLOR = DecisionLabelColor.red;

export const DECISION_LABEL_COLOR_OPTIONS: {
  color: DecisionLabelColor;
  name: string;
}[] = [
  { color: DecisionLabelColor.gray, name: "Grey" },
  { color: DecisionLabelColor.red, name: "Red" },
  { color: DecisionLabelColor.orange, name: "Orange" },
  { color: DecisionLabelColor.yellow, name: "Yellow" },
  { color: DecisionLabelColor.green, name: "Green" },
  { color: DecisionLabelColor.blue, name: "Blue" },
  { color: DecisionLabelColor.purple, name: "Purple" },
  { color: DecisionLabelColor.pink, name: "Pink" },
];

const decisionLabelColorSet = new Set<string>(DECISION_LABEL_COLORS);

export function isDecisionLabelColor(
  value: string | null | undefined,
): value is DecisionLabelColor {
  return value != null && decisionLabelColorSet.has(value);
}

export function resolveDecisionLabelColor(
  value: string | null | undefined,
  fallback: DecisionLabelColor,
): DecisionLabelColor {
  return isDecisionLabelColor(value) ? value : fallback;
}
